export default __webpack_public_path__ + "static/media/mounjaro-icon.06fd8a94.png";